import {
  OrderPayableBy,
  OrderPayableTo,
  EstimateSplitFulfillmentStatus,
} from "../../../views/Orders/enums";
import { getTradingDefaultsFromOrder } from "./resolveDefaultEstimateSplitTransactionType";

export interface EstimateSplitPatchPayload {
  transactionType?: string;
  discountPercentage?: number;
  creditNotePercentage?: number;
  fulfillmentStatus?: EstimateSplitFulfillmentStatus;
  payableBy?: OrderPayableBy;
  payableTo?: OrderPayableTo;
}

export function buildEstimateSplitPatchPayload(input: {
  transactionType?: string;
  discountPercentage?: number;
  creditNotePercentage?: number;
  fulfillmentStatus?: EstimateSplitFulfillmentStatus;
  payableBy?: OrderPayableBy;
  payableTo?: OrderPayableTo;
}): EstimateSplitPatchPayload {
  const payload: EstimateSplitPatchPayload = {};
  if (input.transactionType) {
    payload.transactionType = input.transactionType;
  }
  if (
    input.discountPercentage != null &&
    input.discountPercentage !== 0
  ) {
    payload.discountPercentage = input.discountPercentage;
  }
  if (
    input.creditNotePercentage != null &&
    input.creditNotePercentage !== 0
  ) {
    payload.creditNotePercentage = input.creditNotePercentage;
  }
  if (input.fulfillmentStatus) {
    payload.fulfillmentStatus = input.fulfillmentStatus;
  }
  if (input.payableBy) {
    payload.payableBy = input.payableBy;
  }
  if (input.payableTo) {
    payload.payableTo = input.payableTo;
  }
  return payload;
}

export function canPersistEstimateSplitConfig(
  estimateNo: string | undefined,
  splitId: string | undefined,
): boolean {
  return (
    Boolean(estimateNo?.trim()) &&
    Boolean(splitId?.trim()) &&
    /^[a-f\d]{24}$/i.test(splitId!.trim())
  );
}

export function buildDefaultEstimateSplitPatchPayload(
  transactionType: string,
  orderData?: any,
): EstimateSplitPatchPayload {
  if (!transactionType) {
    return {};
  }
  const { discount, credit } = getTradingDefaultsFromOrder(orderData);
  return buildEstimateSplitPatchPayload({
    transactionType,
    discountPercentage: discount,
    creditNotePercentage: credit,
  });
}
